import { useState } from "react";
import { hardResetProgress, useGameStore } from "../state/useGameStore";
import { STAGE_ORDER, UPGRADES } from "../config/game";

function resumeStage(unlockedIds) {
  for (const id of STAGE_ORDER) {
    if (unlockedIds.includes(id)) {
      return UPGRADES.find((u) => u.id === id)?.name ?? id.toUpperCase();
    }
  }
  return "FORM";
}

export function Intro() {
  const start = useGameStore((s) => s.start);
  const phase = useGameStore((s) => s.phase);
  const clickCount = useGameStore((s) => s.clickCount);
  const score = useGameStore((s) => s.score);
  const unlockedIds = useGameStore((s) => s.unlockedIds);
  const [confirmReset, setConfirmReset] = useState(false);

  if (phase !== "intro") return null;

  const hasProgress = clickCount > 0 || unlockedIds.length > 0;
  const stage = resumeStage(unlockedIds);

  const handleReset = () => {
    if (!confirmReset) {
      setConfirmReset(true);
      return;
    }
    hardResetProgress();
    setConfirmReset(false);
  };

  return (
    <section className="intro" aria-labelledby="heap-title">
      <div className="intro__frame">
        <p className="intro__eyebrow">HEAP</p>
        <h1 id="heap-title" className="intro__quote">
          A process cannot be understood by stopping it.
          <span>It must be studied in motion.</span>
        </h1>

        {hasProgress && (
          <p className="intro__resume">
            Returned mass {score.toLocaleString()} · stage {stage}
          </p>
        )}

        <div className="intro__actions">
          <button type="button" className="cta" onClick={start}>
            <span className="cta__label">{hasProgress ? "Continue" : "Begin"}</span>
            <span className="cta__arrow" aria-hidden="true">
              →
            </span>
          </button>

          {hasProgress && (
            <button
              type="button"
              className={`cta cta--ghost intro__reset ${confirmReset ? "is-armed" : ""}`}
              onClick={handleReset}
              onBlur={() => setConfirmReset(false)}
            >
              <span className="cta__label">
                {confirmReset ? "Confirm reset" : "Reset"}
              </span>
            </button>
          )}
        </div>

        <p className="intro__hint">
          {hasProgress ? "Enter or Space to continue" : "Enter or Space"}
        </p>
      </div>
    </section>
  );
}
